var _rect, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodNonVeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 13,
    height: 13,
    fill: "white",
    stroke: "#600000",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 6.5,
    y: 6.5,
    width: 11,
    height: 11,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "8,5 8,19 19,12",
    fill: "#600000",
    transform: "rotate(-90, 12, 12)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodNonVeg);
export default __webpack_public_path__ + "static/media/food_non_veg.ad6f3d130d1b028739e4b84d9954d01e.svg";
export { ForwardRef as ReactComponent };